export const ErrorCode = {
  AuthenticationError: 401,
  Conflict: 409
}
